import { render } from "./AddEditChapterModal.vue?vue&type=template&id=29af8926&scoped=true"
import script from "./AddEditChapterModal.vue?vue&type=script&lang=js"
export * from "./AddEditChapterModal.vue?vue&type=script&lang=js"

import "./AddEditChapterModal.vue?vue&type=style&index=0&id=29af8926&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29af8926"]])

export default __exports__